export var ScheduleStatus;
(function (ScheduleStatus) {
    ScheduleStatus[ScheduleStatus["AVAILABLE"] = 1] = "AVAILABLE";
    ScheduleStatus[ScheduleStatus["BLOCKED"] = 50] = "BLOCKED";
})(ScheduleStatus || (ScheduleStatus = {}));
//# sourceMappingURL=schedule-status.js.map